export default {
  title: 'Empresas',
  searchSchedule: {
    partner: 'Para parceiros, a busca de empresas funciona apenas em dias úteis.',
    trial: 'Durante o período de teste, a busca de empresas funciona apenas em dias úteis.',
    everyDay: 'A busca de empresas funciona todos os dias, inclusive nos fins de semana.',
  },
  description: 'Acompanhe as empresas encontradas nas buscas de prospecção, complete seus dados e veja o andamento da análise antes de seguir com o contato direto.',
  form: {
    title: 'Cadastro de empresa',
    description: `Informe os dados que conhece.<br>
   Basta CNPJ, razão social, nome fantasia, site ou LinkedIn<br> 
   para iniciarmos a busca e o enriquecimento da empresa.`,
  },
  labels: { new: 'Novo candidato', import: 'Importar' },
  groups: { company: 'Dados iniciais', scanner: 'Análise do Scanner' },
  contacts: {
    title: 'Contatos',
    fields: {
      name: 'Nome',
      jobTitle: 'Cargo', 
      channel: 'Canal', 
      origin: 'Origem', 
      status: 'Status', 
      email: 'E-mail', 
      phone: 'Telefone', 
      linkedin: 'LinkedIn', 
      function: 'Área da pessoa', 
      whatsapp: 'O telefone é o WhatsApp pessoal desta pessoa'
    },
    functions: { 
      general: 'Liderança geral', 
      technology: 'Tecnologia', 
      sales: 'Vendas', 
      marketing: 'Marketing', 
      finance: 'Financeiro', 
      operations: 'Operações', 
      people: 'Pessoas e RH', 
      customer: 'Atendimento ao cliente', 
      legal: 'Jurídico e compliance', 
      procurement: 'Compras e suprimentos', 
      engineering: 'Engenharia', 
      product: 'Produto', 
      quality: 'Qualidade', 
      security: 'Segurança' 
    },
    feedback: { 
      title: 'Marcar contato público', 
      status: 'O que há com este contato?', 
      note: 'Observação'
    },
    origins: { 
      peoplescan: 'Busca pública', 
      manual: 'Manual'
     },
    channels: { 
      email: 'E-mail', 
      phone: 'Telefone', 
      whatsapp: 'WhatsApp', 
      linkedin: 'LinkedIn', 
      unknown: 'Não informado' 
    },
    statuses: { current: 'Atual', unverified: 'Vínculo não verificado', stale: 'Desatualizado', invalid: 'Inválido', outdated: 'Desatualizado', do_not_use: 'Não utilizar' },
  },
  contactability: { direct: 'Direto', institutional: 'Institucional', na: 'N/A' },
  scoreBasis: { verified: 'Comprovado por fatos', unverified: 'Sem comprovação por fatos' },
  // Classe comercial da nota vigente (90 / 75 / 60). Nota histórica de versão anterior não tem classe.
  // A nota pertence à avaliação atual (política vigente) ou a uma anterior, preservada como foi gravada.
  scoreOrigin: { true: 'Atual', false: 'Anterior' },
  scoreClasses: { excellent: 'Excelente', good: 'Boa', regular: 'Regular', below_minimum: 'Abaixo do mínimo' },
  fields: {
    candidate: 'Empresa',
    company: 'Empresa',
    offers: 'Ofertas',
    bestOffer: 'Melhor avaliada',
    qualifiedOffer: 'Oferta qualificada',
    seedContact: 'Contato do LinkedIn',
    legalName: 'Razão social',
    tradeName: 'Nome fantasia',
    domain: 'Site', country: 'País',
    documentType: 'Documento',
    documentNumber: 'Número do documento',
    status: 'Status',
    score: 'Score',
    scoreBasis: 'Base do Score',
    scoreClass: 'Classe da nota',
    scoreOrigin: 'Avaliação da nota',
    coverage: 'Cobertura',
    contact: 'Contato',
    createdAt: 'Vinculado em',
  },
  readiness: {
    assessment_incomplete: 'A avaliação das ofertas ainda não foi concluída',
    offer_excluded: 'Todas as suas ofertas foram descartadas por incompatibilidade comprovada com o escopo que você declarou',
    applicability_missing: 'Nenhuma oferta tem, até agora, um fato do candidato que mostre que ela resolve algo real para ele',
    score_insufficient_context: 'Ainda não há contexto suficiente para avaliar a oferta',
    score_policy_pending: 'A avaliação comercial ainda não foi definida',
    score_below_prospect_threshold: 'A nota comercial ficou abaixo do mínimo para prospect',
    coverage_below_prospect_threshold: 'Há uma oferta qualificada, mas ainda não conhecemos a empresa o bastante para tratá-la como prospect',
    lowscan_not_approved: 'Ainda não confirmamos que esta empresa ou pessoa existe e está ativa',
    coverage_stale: 'As informações públicas da empresa estão sendo atualizadas antes da avaliação',
    coverage_below_gate: 'Ainda não coletamos informações públicas suficientes sobre a empresa',
    hiscan_not_executed: 'A análise aprofundada da empresa ainda não foi feita',
    contact_channel_missing: 'Ainda não há nenhum canal utilizável da empresa para abordar',
    no_active_offers: 'Você ainda não tem ofertas ativas para avaliar',
  },
  states: {
    registered: 'Cadastrado',
    filling: 'Preenchendo dados',
    enriching: 'Enriquecendo',
    evaluating: 'Avaliando',
    waiting: 'Em espera',
    pending_contact: 'Buscando contato',
    nurturing: 'Em acompanhamento',
    awaiting_reevaluation: 'Aguardando reavaliação',
    prospect: 'Prospect',
    not_qualified: 'Não qualificado'
  },
  messages: {
    admissionPending: 'Recebemos o cadastro. Como o limite diário de novos candidatos já foi usado, ele aguarda na fila e entrará na análise assim que houver vaga.',
    importAdmissionPending: 'Importação recebida. Parte dos candidatos aguarda na fila porque o limite diário de novos candidatos foi atingido; eles entrarão na análise nos próximos dias, na ordem do arquivo.',
    handoffCompleted: 'Empresa enviada para Leads.',
      dossierRefreshed: 'Dossiê atualizado.',
  },
  errors: {
    entryRequired: 'Informe ao menos um dado inicial do candidato.',
    globalFieldLocked: 'Esta empresa é compartilhada com outras contas ou já tem identidade oficial, por isso os dados já preenchidos não podem ser alterados por aqui. Você ainda pode completar campos vazios.',
    duplicateEntry: 'Já existe outra empresa cadastrada com este mesmo dado.',
    dossierNotFound: 'Não encontramos um dossiê para esta empresa neste tenant.',
    dossierFailed: 'Não foi possível abrir o dossiê agora. Tente novamente.',
    handoffFailed: 'Não foi possível enviar a empresa para Leads.',
      dossierRefreshFailed: 'Não foi possível atualizar o dossiê agora. O prazo para uma nova atualização não foi alterado.',
      dossierRefreshNotYet: 'O dossiê só pode ser atualizado 180 dias depois da primeira avaliação ou da última atualização. Próxima data: [[date]].',
      dossierRefreshInProgress: 'Já existe uma atualização deste dossiê em andamento.',
    automaticProspectingFailed: 'Não foi possível alterar a busca automática agora. Tente novamente.',
  },
  actions: {
    dossier: 'Ver dossiê',
    dossierTooltip: 'Abrir o dossiê completo desta empresa (disponível quando a avaliação comercial termina)',
      refreshDossier: 'Atualizar dossiê',
      refreshDossierTooltip: 'Reavaliar esta empresa com as informações mais recentes. Disponível 180 dias depois da primeira avaliação ou da última atualização.',
    generateProspectingConversation: 'Criar abordagem com IA',
    generateProspectingConversationTooltip: 'Gerar uma conversa exclusiva para uma Offer qualificada e contato LinkedIn verificado; usa créditos de IA somente após confirmar a oferta.',
    sendToCrm: 'Enviar para o CRM',
    sendToCrmTooltip: 'Enviar esta empresa aprovada para Leads',
  },
  prospectingConversation: {
    cancel: 'Cancelar',
    generate: 'Gerar abordagem com IA',
    close: 'Fechar',
    chooseTitle: 'Selecionar a oferta para uma abordagem contextual',
    chooseLabel: 'Oferta a abordar',
    chooseHint: 'A geração usa IA e só consome orçamento após você confirmar. O texto será uma sugestão editável e não será enviado.',
    noChoices: 'Ainda não há uma Offer com evidência e LinkedIn individual confirmado. Não foi realizada chamada de IA.',
    generateFailed: 'Não foi possível gerar uma abordagem comercial contextual. Nenhum texto genérico será exibido como alternativa.',
    generatedTitle: 'Abordagem criada por IA — revise antes de usar',
    angle: 'Estratégia comercial para este contato',
    invitation: 'Convite de conexão no LinkedIn',
    firstMessage: 'Mensagem após a conexão',
    followUp: 'Acompanhamento, se houver contexto para retomar',
    discoveryQuestion: 'Pergunta de descoberta',
    source: 'Fonte factual utilizada',
    reviewHint: 'Confirme a identidade, pertinência, veracidade e tom. A mensagem não foi enviada e pode ser editada.',
  },
  // Busca automática de empresas do próprio tenant: pausar não apaga nada (candidatos, notas, contatos e dossiês continuam disponíveis) e não gera cobrança.
  automatic: {
    label: 'Busca automática de empresas',
    pauseTooltip: 'Pausar a busca automática de novas empresas. Sua carteira continua disponível e nenhuma nova consulta paga é feita enquanto estiver pausada.',
    resumeTooltip: 'Retomar a busca automática de novas empresas. Ela volta ao ritmo do seu plano, sem acumular os dias em que ficou pausada.',
  },
  dossier: {
    kicker: 'Dossiê Comercial',
    title: 'Dossiê da empresa',
    description: 'Resumo organizado do que encontramos de público sobre esta empresa: quem ela é, o que oferece, com quem falar e o que ainda não conseguimos confirmar. Cada informação mostra de onde veio.',
    empty: 'O dossiê fica disponível quando a avaliação comercial desta empresa termina.',
    fileName: 'dossie',
    dash: '—',
    meta: { generatedAt: 'Gerado em', document: 'Documento', website: 'Site' },
    verdictTitle: 'Veredito comercial',
    verdicts: {
      awaiting_reevaluation: 'Aguardando reavaliação. Esta empresa foi avaliada em uma versão anterior da análise e a avaliação vigente ainda não foi concluída. As informações abaixo são preservadas, mas não representam uma qualificação atual.',
      prospect: 'Prospect. Há uma oferta qualificada e um contato direto para abordar a empresa.',
      prospect_institutional: 'Prospect. Há uma oferta qualificada e um canal institucional da empresa para a primeira abordagem. A busca por uma pessoa de contato continua.',
      pending_contact: 'Oferta qualificada. Ainda não há um canal utilizável para abordar a empresa; a busca por contato continua.',
      nurturing_coverage: 'Oferta qualificada, mas ainda conhecemos pouco da empresa para tratá-la como prospect. Ela fica em acompanhamento até haver mais informações.',
      nurturing: 'Oferta qualificada, mas a busca terminou sem encontrar um canal utilizável. A empresa fica em acompanhamento.',
      not_qualified_no_offer: 'Nenhuma oferta atingiu a nota mínima de 60 (maior nota: [[summary.score]]). Isso não significa que a empresa não precise delas, apenas que ainda não há evidências suficientes.',
      not_qualified: 'Não qualificado. A avaliação não atingiu o mínimo para prospect; o motivo principal está abaixo.',
    },
    // Leitura comercial por força da evidência: explica o que o fato permite afirmar, sem inventar necessidade.
    readings: {
      contextual: 'O fato abaixo mostra que a empresa atua em um contexto compatível com esta oferta. Ele não comprova uma necessidade: serve de ponto de partida para uma conversa de investigação comercial.',
      relevant: 'O fato abaixo é pertinente ao que esta oferta entrega e indica uma oportunidade plausível. Ainda é uma hipótese a confirmar com a empresa, não uma necessidade declarada.',
      strong: 'O fato abaixo aponta uma necessidade comercial específica ligada a esta oferta. Vale confirmar o contexto e a prioridade na abordagem.',
      decisive: 'O fato abaixo mostra uma intenção atual e atribuível à empresa de contratar o que esta oferta entrega.',
    },
    linkNotes: {
      unverified: 'O vínculo desta pessoa com a empresa ainda não foi confirmado.',
    },
    notDetermined: 'Nenhuma oportunidade comprovada',
    offerEvidenceStates: {
      current: 'Avaliação vigente: os fatos abaixo foram considerados pela análise atual.',
      historical: 'Registro histórico: os fatos abaixo pertencem a uma avaliação anterior e NÃO comprovam qualificação comercial vigente.',
      not_assessed: 'Esta oferta ainda não foi avaliada na versão vigente.',
    },
    offerEvidenceDiagnoses: {
      unproven_no_counter: 'Nenhuma evidência favorável foi aceita e nenhuma contraevidência foi registrada. A nota abaixo do corte decorre da insuficiência de evidências, NÃO de fatos que contraindiquem esta oferta.',
      direct_competitor: 'Concorrência direta documentada com o mesmo escopo: esta oferta foi zerada. Veja a contraevidência citada abaixo.',
      favorable_recorded: 'Há evidências favoráveis registradas. Isso demonstra aderência de contexto, não necessidade ou intenção de compra comprovada.',
      counter_recorded: 'Há contraevidências documentadas. Confira quais fatos sustentam a restrição.',
      not_demonstrated: 'A avaliação vigente não reconheceu evidência suficiente para sustentar a oferta; isso não comprova que a empresa não precise dela.',
    },
    scoreNoteTitle: 'Sobre a avaliação',
    scoreNote: 'Cada oferta é avaliada individualmente a partir de informações verificadas sobre a empresa. A análise considera indícios relevantes para a oportunidade comercial, consistência das evidências e eventuais restrições identificadas. Informações não encontradas representam incerteza, e não uma conclusão sobre a necessidade da empresa.',
    // Disponibilidade da composição da nota de cada oferta (só aparece quando NÃO há composição vigente gravada).
    compositionStatus: {
      historical: 'Esta avaliação é de uma versão anterior da nota e não vale como avaliação vigente. A nota vigente só existe depois que a empresa for avaliada novamente.',
      not_assessed: 'Esta oferta ainda não tem uma avaliação válida para a empresa.',
      unavailable: 'A composição desta nota não está disponível.',
    },
    quote: 'Trecho da fonte',
    scoreBasisTitle: 'Composição factual do Score',
    opportunityKind: 'Natureza da oportunidade',
    opportunityKinds: {
      hypothesis: 'Hipótese comercial sustentada por contexto operacional',
      declared_event: 'Oportunidade ligada a um evento documentado',
      operational_fit: 'Aplicabilidade sustentada por uma operação existente',
      specific_need: 'Necessidade comercial específica e documentada',
      declared_intent: 'Intenção atual e atribuível de contratar',
    },
    scoreBasisFields: {
      base: 'Ponto de partida',
      evidence: 'Força do fundamento factual (+)',
      corroboration: 'Corroboração entre fontes (+)',
      diversity: 'Diversidade dos fatos (+)',
      matching: 'Aderência ao uso ou gatilho (+)',
      deductions: 'Contraevidências comprovadas (−)',
      substantiated_facts: 'Fatos relevantes confirmados',
      distinct_sources: 'Fontes distintas utilizadas',
    },
    counterStatus: { none: 'Nenhuma contraevidência comprovada.' },
    groundings: {
      founded: 'Oportunidade fundamentada: há indício favorável identificado',
      exploratory: 'Oportunidade exploratória: a necessidade ainda não foi comprovada',
    },
    // Origem da nota exibida: avaliação vigente gravada, ou projeção SOMENTE LEITURA de uma avaliação anterior (nunca gravada como nota vigente).
    evaluationOrigins: {
      persisted: 'Avaliação vigente',
      projected: 'Projeção a partir de uma avaliação anterior (somente leitura)',
      indicative: 'Estimativa indicativa a partir de uma avaliação anterior',
    },
    // Origem do Score PRINCIPAL (o mesmo da grade): avaliação vigente ou avaliação anterior gravada (versão histórica, rotulada).
    scoreOrigins: {
      current: 'Avaliação vigente',
      historical: 'Avaliação anterior (versão histórica)',
    },
    // Origem da RECOMENDAÇÃO de oferta (distinta do Score principal): a avaliação vigente da própria Offer ou, só quando ela não tem avaliação vigente, a projeção de uma avaliação anterior.
    recommendationOrigins: {
      current_evaluation: 'Avaliação vigente',
      historical_projection: 'Recomendação exploratória: projeção de avaliação anterior (somente leitura)',
      mixed: 'Avaliação vigente e projeção de avaliação anterior (empate)',
    },
    scoreBreakdownTitle: 'Composição da nota',
    scoreBreakdown: { deductions: 'O que reduziu a nota', gains: 'O que acrescentou pontos' },
    scoreComponents: {
      coverage_uncertainty: 'Parte da empresa que ainda não conhecemos',
      favorable_indication_gap: 'Nenhum indício favorável identificado no que já conhecemos',
      favorable_evidence_insufficiency: 'Poucas evidências favoráveis independentes para esta oferta',
      commercial_strength_contextual: 'Evidência de contexto compatível com a oferta',
      commercial_strength_relevant: 'Evidência relevante e específica para a oferta',
      commercial_strength_strong: 'Evidência forte de necessidade comercial',
      commercial_strength_decisive: 'Evidência decisiva: intenção atual e atribuível de contratar',
      direct_competitor: 'Concorrente direto: vende o mesmo escopo desta oferta',
      evidence_strength: 'Força do fundamento factual',
      source_corroboration: 'Corroboração entre fontes',
      source_diversity: 'Diversidade dos fatos',
      direct_match: 'Aderência ao uso ou gatilho',
      offer_scope_excluded: 'A oferta declara este caso como fora do escopo',
      core_problem_contradicted: 'O problema que a oferta resolve não existe ou já foi resolvido',
      technical_operational_incompatibility: 'Incompatibilidade técnica ou operacional',
      commercial_model_conflict: 'Incompatibilidade com o modelo comercial',
      timing_counterevidence: 'O momento da empresa não combina com a oferta',
      material_objection_or_risk: 'Objeção ou risco relevante documentado',
    },
    undetermined: {
      below_minimum: 'Nenhuma oferta atingiu a nota mínima de 60. Isso não comprova que a empresa não precise delas.',
      version_pending: 'A avaliação desta empresa é de uma versão anterior da nota e ainda não foi atualizada. O estado atual foi preservado.',
      not_assessed: 'A avaliação entre esta empresa e as suas ofertas ainda não foi concluída.',
      no_applicability: 'A pesquisa não encontrou fundamento suficiente para recomendar uma oferta com segurança. Isso não comprova que a empresa não precise dela.',
      excluded: 'As ofertas aplicáveis foram excluídas por contraevidência comprovada. Por isso nenhuma é recomendada.',
    },
    contactStatus: {
      direct: 'Direto: há uma pessoa identificada com ao menos um canal individual para abordar. É a melhor forma de contato.',
      institutional: 'Institucional: há um canal utilizável da empresa (loja, WhatsApp corporativo, central ou e-mail de vendas). A busca por uma pessoa de contato continua.',
      na: 'N/A: ainda não encontramos nenhum canal utilizável.',
    },
    prospectingStart: {
      publishedFact: 'Fato da empresa a utilizar na conversa',
      steps: 'Sequência sugerida',
      discovery: 'Pergunta para entender a operação',
      phases: {
        ready: 'Perfil e vínculo confirmados: roteiro disponível para abordagem manual pelo LinkedIn.',
        verify_link: 'Existe um perfil público, mas o vínculo atual não está confirmado. Verifique antes de abordar.',
        find_linkedin: 'A pessoa foi identificada, mas ainda falta localizar um perfil individual no LinkedIn.',
        find_person: 'A oferta é qualificada, mas nenhuma pessoa foi identificada. Identifique a função responsável antes de abordar.',
        qualification_or_contact_pending: 'Oferta comercialmente qualificada, mas o estado do contato/Prospect ainda não permite iniciar a abordagem.',
        missing_evidence: 'Não foi recuperado um fato favorável citável para iniciar uma conversa sem inventar contexto. Revise a avaliação.',
      },
      actions: {
        confirm_offer_evidence: 'Identificar uma evidência favorável da oferta com fonte e justificativa antes de preparar o contato.',
        review_evidence: 'Ler a fonte original e confirmar que o fato publicado é atribuído à empresa e pertinente a esta oferta.',
        validate_contact: 'Confirmar quem exerce a função relacionada à oferta e se há um perfil pessoal atual no LinkedIn.',
        locate_linkedin_contact: 'Localizar um profissional relevante no LinkedIn. Não iniciar contato por e-mail.',
        open_person_search: 'Usar o link de pesquisa nominal no LinkedIn e confirmar a identidade do perfil.',
        check_profile_affiliation: 'Abrir o perfil e verificar empresa atual, cargo e pertinência para este assunto.',
        send_connection: 'Enviar convite de conexão pelo LinkedIn, personalizado e sem alegar problema que não foi comprovado.',
        start_with_evidence: 'Após a conexão, mencionar brevemente o fato publicado e sua fonte; não presumir necessidade nem intenção de compra.',
        ask_open_question: 'Fazer uma pergunta de descoberta ligada a esta oferta e aguardar a resposta antes de apresentar solução.',
        propose_conversation_on_interest: 'Somente se houver interesse, sugerir uma conversa breve sobre o tema; não pressupor decisão de compra.',
      },
    },
    linkedinRoute: {
      title: 'Pessoas identificadas e caminho de acesso no LinkedIn',
      fallback: 'Alternativa institucional quando o LinkedIn não permitir contato',
      channels: {
        profile: 'Perfil pessoal no LinkedIn — abrir pelo nome acima',
        search: 'Pesquisa no LinkedIn — perfil individual ainda não localizado',
      },
      verification: {
        current: 'Vínculo profissional atual validado na fonte disponível',
        unverified: 'Vínculo atual não verificado; confirmar pessoa e empresa antes da abordagem',
      },
      focus: {
        sales: 'Primeiro assunto: relacionamento, propostas e operação comercial',
        operations: 'Primeiro assunto: coordenação das entregas e processos',
        technology: 'Primeiro assunto: tecnologia, integrações e projetos',
        leadership: 'Primeiro assunto: patrocínio e direcionamento estratégico',
        other: 'Primeiro assunto: identificar o responsável adequado',
      },
    },
    buyingRoute: 'Rota de compra',
    routeStatus: {
      identified: 'Identificada: há uma pessoa com vínculo atual e função relevante para a sua oferta, ou uma pessoa que você cadastrou.',
      partial: 'Parcial: só há uma pessoa com vínculo ainda não verificado ou uma porta de entrada da empresa. Quem decide a compra ainda não está comprovado.',
      unknown: 'Não identificada: ainda não sabemos por onde chegar a quem decide. Isso não tira a empresa da lista.',
    },
    jobTitleUnknown: 'Cargo não identificado',
    sections: {
      summary: 'Resumo executivo',
      identity: 'Identidade',
      commercialProfile: 'Perfil comercial',
      profile: 'Perfil da empresa',
      business: 'O que a empresa vende e para quem',
      movements: 'Movimentos e sinais relevantes',
      externalSources: 'Fontes externas independentes',
      recommendation: 'Oportunidade comercial',
      recommendationTie: 'Ofertas igualmente recomendadas',
      recommendationUndetermined: 'Oferta recomendada',
      why: 'Por que a oferta se aplica',
      risks: 'Contraevidências e riscos',
      contacts: 'Rota de prospecção por LinkedIn',
      prospectingStart: 'Como iniciar a prospecção pelo LinkedIn',
      approach: 'Assuntos legítimos para abordagem',
      questions: 'Perguntas de validação',
      comparison: 'Comparação das ofertas',
      offerEvidence: 'Fatos e contraevidências por oferta',
      offerSupport: 'Evidências favoráveis registradas',
      offerRisks: 'Contraevidências documentadas',
      offerDiscovery: 'Contexto empresarial a investigar — não qualifica a oferta',
      offerDiscoveryQuestions: 'Perguntas de descoberta — não são fatos comprovados',
      missing: 'O que ainda falta saber',
      sources: 'Fontes',
    },
    sectionHints: {
      commercialProfile: 'O que a empresa faz e vende, organizado a partir do que ela mesma publica. Cada item mostra o trecho e a fonte.',
      profile: 'O que a própria empresa diz de si, com a fonte de cada informação.',
      business: 'O que a EMPRESA observada vende e a quem atende, como ela mesma declara (não são as suas ofertas).',
      movements: 'Publicações e vagas abertas que a empresa divulga.',
      externalSources: 'O que fontes fora do site da empresa dizem sobre ela (cadastros, imprensa, parceiros). Cadastro empresarial confirma identidade, mas não indica oportunidade.',
      recommendation: 'Ofertas qualificadas para esta empresa, cada uma com o fato que a sustenta e o que ele permite afirmar.',
      recommendationTie: 'Mais de uma oferta tem a mesma maior nota e são possibilidades equivalentes; não há desempate arbitrário.',
      why: 'Fatos publicados pela empresa que mostram onde a oferta se encaixa, com o trecho e a fonte.',
      risks: 'O que pesa contra a oferta, quando existe fato documentado.',
      contacts: 'Pessoas encontradas em fontes públicas, ordenadas para pesquisa e contato no LinkedIn. Perfil pessoal real é diferente de busca por nome; vínculo e papel de compra exigem confirmação. E-mail não compõe esta rota.',
      prospectingStart: 'Plano prático por oferta qualificada, com pessoa, fonte, abertura e pergunta. Perfil não verificado é uma tarefa de pesquisa, não uma autorização de contato. Nenhuma nova busca é executada para gerar estas sugestões.',
      approach: 'Pontos de partida para a conversa, ligados a fatos publicados. Não afirmam que a empresa tenha um problema.',
      questions: 'Perguntas abertas para entender o contexto da empresa na conversa. Perguntas não são fatos.',
      comparison: 'Todas as suas ofertas ativas e a nota de cada uma.',
      offerEvidence: 'O que as fontes permitem afirmar sobre cada oferta, inclusive fatos de avaliações anteriores identificados como históricos. Sem fatos não há justificativa inventada.',
      missing: 'O que ainda não encontramos e que ajudaria a abordar esta empresa.',
      sources: 'Páginas consultadas para montar este documento.',
    },
    limitationsTitle: 'Limitações da pesquisa',
    commercialGroups: { activities: 'Atividades', offers: 'Produtos e serviços que a empresa oferece', capabilities: 'O que a empresa faz', triggers: 'Movimentos que podem abrir conversa' },
    businessGroups: { operationalAreas: 'Áreas e responsabilidades descritas pela empresa (não comprovam quadro de pessoal)', markets: 'Mercados e públicos atendidos', clients: 'Clientes citados', cases: 'Cases publicados', partners: 'Parceiros', integrations: 'Integrações' },
    profileFields: { founded: 'Fundação', employees: 'Colaboradores', areas: 'Áreas de atuação', certifications: 'Certificações', locations: 'Endereço' },
    nextSteps: {
      approach: 'Abordar a empresa com a oferta recomendada e os assuntos abaixo.',
      applicability_missing: 'Reavaliar quando a empresa publicar novas informações ou quando o catálogo de ofertas mudar.',
      score_below_prospect_threshold: 'Não há oportunidade comprovada para as suas ofertas neste momento. Reavalie quando houver novas informações sobre a empresa ou mudanças no seu catálogo.',
      assessment_incomplete: 'Concluir a avaliação das suas ofertas.',
      offer_excluded: 'Rever o escopo declarado das ofertas ou aguardar novas informações públicas da empresa.',
      contact_channel_missing: 'Cadastrar um canal da empresa (e-mail de vendas, telefone, WhatsApp ou loja) ou aguardar a próxima busca pública.',
      offer_assessment: 'Concluir a avaliação das suas ofertas.',
    },
    pendingCodes: {
      offer_assessment: 'Avaliar as suas ofertas com contexto suficiente',
      score_insufficient_context: 'Ainda não há contexto suficiente para avaliar a oferta',
      score_policy_pending: 'A avaliação comercial ainda não foi definida',
      score_below_prospect_threshold: 'Nenhuma oferta tem, por enquanto, evidências suficientes de oportunidade',
      independent_sources_absent: 'Não encontramos fontes independentes da empresa (imprensa, parceiros ou clientes) além de cadastros e redes sociais',
      clients_not_found: 'Não encontramos clientes, cases ou depoimentos publicados',
      partners_not_found: 'Não encontramos parcerias ou certificações publicadas',
      lowscan_not_approved: 'Ainda não confirmamos que esta empresa ou pessoa existe e está ativa',
      coverage_stale: 'As informações públicas da empresa estão sendo atualizadas',
      coverage_below_gate: 'Ainda não coletamos informações públicas suficientes sobre a empresa',
      hiscan_not_executed: 'A análise aprofundada da empresa ainda não foi feita',
      applicability_missing: 'No que a empresa publica, não há fato que mostre que alguma das suas ofertas se aplica a ela',
      assessment_incomplete: 'A avaliação das suas ofertas não foi concluída',
      offer_excluded: 'Todas as suas ofertas foram descartadas por incompatibilidade comprovada com o escopo declarado',
      contact_channel_missing: 'Ainda não há nenhum canal utilizável da empresa para abordar',
      no_active_offers: 'Você ainda não tem ofertas ativas para avaliar',
      official_site: 'Site oficial',
      institutional_pages: 'Páginas institucionais (sobre, contato, equipe)',
      products_services: 'Produtos e soluções da empresa',
      web_technology: 'Tecnologias do site',
      email_infrastructure: 'Servidor de e-mail do domínio',
      tls_identity: 'Certificado de segurança do site',
      public_channels: 'Canais públicos de contato da empresa',
      public_movements: 'Publicações públicas da empresa',
      hiring_signals: 'Vagas abertas',
      developer_documentation: 'Documentação para desenvolvedores',
    },
    fields: {
      legalName: 'Razão social',
      tradeName: 'Nome fantasia',
      document: 'Documento',
      website: 'Site',
      location: 'Cidade / UF',
      country: 'País',
      activity: 'Atividade principal',
      state: 'Status',
      bestScore: 'Score',
      scoreOrigin: 'Origem do Score',
      projectedScore: 'Projeção na política vigente (somente leitura)',
      recommendationOrigin: 'Origem da recomendação',
      mainOffer: 'Melhor avaliada',
      pending: 'Motivo principal',
      nextStep: 'Próximo passo',
      offer: 'Oferta',
      offerType: 'Tipo',
      offerScore: 'Nota (Score)',
      scoreClass: 'Classe da nota',
      grounding: 'Fundamentação',
      evaluationOrigin: 'Origem da nota',
      offerStatus: 'Situação da avaliação',
      evaluatedAt: 'Avaliada em',
      found: 'Informações básicas encontradas',
    },
    columns: {
      name: 'Nome', jobTitle: 'Cargo', linkedin: 'LinkedIn', email: 'E-mail', phone: 'Telefone', source: 'Fonte',
      date: 'Data', origin: 'Origem', title: 'Título', offer: 'Oferta', offerType: 'Tipo', score: 'Nota', situation: 'Situação',
      scoreClass: 'Classe', deductionsTotal: 'Deduções (−)', gainsTotal: 'Bônus (+)',
    },
    channels: { title: 'Canais da empresa (não são de uma pessoa)', emails: 'E-mails', phones: 'Telefones', whatsapp: 'WhatsApp', socials: 'Redes sociais' },
    jobs: 'Vagas públicas',
    assessment: { applicability: 'Fatos que sustentam a aplicação', counterevidence: 'Contraevidências' },
    sourceKinds: { profile: 'Site', products: 'Produtos', people: 'Pessoas', movements: 'Publicações', external: 'Fonte externa', technology: 'Tecnologia', channels: 'Contato', jobs: 'Vagas' },
    socialPlatforms: { linkedin: 'LinkedIn', facebook: 'Facebook', instagram: 'Instagram', youtube: 'YouTube', x: 'X (Twitter)', other: 'Outra rede' },
    scoreStatus: { scored: 'Avaliada', insufficient_context: 'Avaliação ainda não concluída', not_assessed: 'Avaliação ainda não concluída' },
    situations: { applicable: 'Aplicabilidade fundamentada', unproven: 'Aplicabilidade não comprovada', not_applicable: 'Aplicabilidade não comprovada', excluded: 'Excluída por contraevidência', not_assessed: 'Avaliação ainda não concluída' },
    counterevidence: {
      offer_scope_excluded: 'A oferta declara este caso como fora do escopo',
      core_problem_contradicted: 'O problema que a oferta resolve não existe ou já foi resolvido',
      technical_operational_incompatibility: 'Incompatibilidade técnica ou operacional',
      commercial_model_conflict: 'Incompatibilidade com o modelo comercial',
      timing_counterevidence: 'O momento da empresa não combina com a oferta',
      material_objection_or_risk: 'Objeção ou risco relevante documentado',
    },
    limitationUnknown: 'Houve uma limitação técnica na coleta',
    limitationCodes: {
      no_active_offers: 'Você ainda não tem ofertas ativas: não há como avaliar a aplicabilidade nem recomendar uma oferta',
      no_people_found: 'Ainda não encontramos pessoas públicas desta empresa',
      people_link_unverified: 'Há pessoas encontradas cujo vínculo atual com a empresa ainda não foi verificado',
      people_partnership_only: 'Há sócios conhecidos pelo cadastro oficial: o vínculo é societário e o cargo atual não foi confirmado',
      people_role_unconfirmed: 'Há pessoas encontradas sem cargo confirmado',
      direct_contact_missing: 'Ainda não há uma pessoa com canal individual e vínculo verificado para abordar; a empresa só tem canal institucional ou nenhum',
      domain_absent: 'O cadastro não informa o site da empresa',
      domain_invalid: 'O site informado não é um endereço válido',
      host_not_public: 'O endereço do site não é público, por isso não foi acessado',
      url_not_allowed: 'O endereço do site usa um formato não permitido para a coleta (porta, protocolo ou credenciais)',
      site_timeout: 'O site demorou demais para responder',
      site_unreachable: 'Não foi possível acessar o site',
      site_not_found: 'O site não foi encontrado',
      redirect_limit_exceeded: 'O site redireciona em excesso',
      redirected_off_domain: 'O endereço do site leva a outro site, que não parece ser da empresa, por isso o conteúdo dele não foi usado',
      response_too_large: 'Uma página era grande demais para ser lida',
      dns_mx_absent: 'O domínio não declara servidor de e-mail',
      dns_mx_unresolved: 'Não foi possível consultar o servidor de e-mail do domínio',
      tls_unavailable: 'Não foi possível consultar o certificado de segurança do site',
      tls_certificate_absent: 'O site não apresentou certificado de segurança',
      no_careers_page: 'Não encontramos página de vagas no site',
      no_documentation_page: 'Não encontramos documentação para desenvolvedores no site',
      no_news_page: 'Não encontramos página de notícias no site',
      no_people: 'Não encontramos pessoas apresentadas no site',
      http_401: 'O site exige login para esta página',
      http_403: 'O site bloqueou o acesso automático',
      http_404: 'Uma página citada pelo site não existe mais',
      http_429: 'O site limitou o número de acessos',
      http_500: 'O site apresentou erro interno',
      http_502: 'O site estava indisponível no momento da coleta',
      http_503: 'O site estava indisponível no momento da coleta',
    },
  },
};
